import { useEffect } from "react";
import MasonCityHeroSection from "./components/HeroSection";
import MasonCityStickyNav from "./components/StickyNav";
import MasonCityProcessingTimeSection from "./components/ProcessingTimeSection";
import MasonCityServicesSection from "./components/ServicesSection";
import MasonCityLocalAreaSection from "./components/LocalAreaSection";
import MasonCityTestimonialsSection from "./components/TestimonialsSection";
import MasonCityAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MasonCityComparisonSection from "./components/ComparisonSection";
import MasonCityMistakesSection from "./components/MistakesSection";
import MasonCityHowItWorksSection from "./components/HowItWorksSection";
import MasonCityFAQSection, { faqs } from "./components/FAQSection";
import MasonCityHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MasonCityFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function MasonCityPage() {
  useEffect(() => {
    document.title = "Emergency Passport Mason City IA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/mason-city/";

    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Mason City, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving River City medical professionals, agriculture travelers, and North Central Iowa families.");
    setMeta("geo.placename", "Mason City, Iowa");
    setMeta("geo.region", "US-IA");
    setMeta("geo.position", "43.1536;-93.2010");
    setMeta("ICBM", "43.1536, -93.2010");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Iowa", item: "https://fastpassportcenter.com/iowa/" },
          { "@type": "ListItem", position: 3, name: "Mason City Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Mason City, MercyOne medical professionals, and North Central Iowa. As fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Mason City", containedInPlace: { "@type": "State", name: "Iowa" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <MasonCityHeroSection />
      <MasonCityStickyNav />
      <MasonCityProcessingTimeSection />
      <MasonCityServicesSection />
      <MasonCityLocalAreaSection />
      <MasonCityTestimonialsSection />
      <MasonCityAcceptanceFacilitiesSection />
      <MasonCityComparisonSection />
      <MasonCityMistakesSection />
      <MasonCityHowItWorksSection />
      <MasonCityFAQSection />
      <MasonCityHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/mason-city" state="IA" />
      <MasonCityFinalCTA />
    </div>
  );
}